import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import LocationsFinder from '~/components/blocks/acf/LocationsFinder';

const LocationsFinderBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockLocationsFinder: { title }
}) => <LocationsFinder {...{ title, globalBlockOptions, attributes }} />;

LocationsFinderBlock.propTypes = {
    blockLocationsFinder: PropTypes.shape({
        title: PropTypes.string
    }).isRequired
};

export default LocationsFinderBlock;

export const fragment = graphql`
    fragment LocationsFinderBlockFragment on WpAcfLocationsFinderBlock {
        name
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        attributes {
            anchor
            className
        }
        blockLocationsFinder {
            title
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Locations Finder Block',
        props: {
            name: 'acf/locations-finder',
            blockLocationsFinder: {
                title: 'Locations Finder Title'
            }
        }
    }
];
